<template>
    <div>
        <Header />
        <PageContainer>
            <h1 class="text-center mb-6">Reset Password</h1>
            <p class="text-center mb-12">
                Please update your password to start using the app
            </p>

            <v-row>
                <v-col class="mb-8">
                    <div class="d-flex justify-center justify-lg-end">
                    <v-form style="width: 500px">
                        <v-text-field
                            :disabled="loading"
                            filled
                            prepend-inner-icon="mdi-email"
                            placeholder="Your e-mail"
                            v-model="email"
                            :rules="[rules.required, rules.email]"
                        >
                        </v-text-field>

                        <v-text-field
                            :disabled="loading"
                            filled
                            prepend-inner-icon="mdi-lock"
                            placeholder="Your new password"
                            type="password"
                            v-model="password"
                            :rules="[rules.required]"
                        >
                        </v-text-field>

                        <v-text-field
                            :disabled="loading"
                            filled
                            prepend-inner-icon="mdi-lock"
                            placeholder="Confirm your new password"
                            type="password"
                            v-model="passwordConfirm"
                            :rules="[rules.required]"
                        >
                        </v-text-field>

                        <v-btn
                            color="secondary"
                            :disabled="!isFormValid || loading"
                            :loading="loading"
                            block
                            class="font-weight-regular text-capitalize px-16"
                            @click="onResetPasswordClicked"
                        >
                            Reset Password
                        </v-btn>
                    </v-form>
                    </div>
                </v-col>
                <v-col>
                    <div class="d-flex justify-center justify-lg-start ps-lg-8">
                        <v-card width="500px">
                            <v-alert
                                style="
                                    border-bottom-left-radius: 0;
                                    border-bottom-right-radius: 0;
                                "
                                type="info"
                            >
                                Your password must contain the following:
                            </v-alert>
                            <div class="px-4 pb-4">
                                <ul>
                                    <li>At least 6 characters</li>
                                </ul>
                            </div>
                        </v-card>
                    </div>
                </v-col>
            </v-row>
        </PageContainer>

        <div class="text-center">
            <v-dialog
                persistent
                v-model="showDialog"
                width="400"
            >
                <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                        Password Reset
                    </v-card-title>

                    <v-card-text style="padding-top: 20px;">
                        Your password has been changed!
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="sendToLogin"
                        >
                            Go to Login page
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import api from "../api";
import toasts from "../utils/toasts";

export default {
    data() {
        return {
            password: "",
            passwordConfirm: "",
            email: "",
            loading: false,
            rules: {
                required: value => !!value || 'Required.',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },
            showDialog: false,
        };
    }, // data

    computed: {
        isFormValid() {
            return (
                this.password != null &&
                this.password.trim().length >= 6 &&
                this.passwordConfirm != null &&
                this.passwordConfirm.trim().length >= 6 &&
                this.password == this.passwordConfirm
            );
        },
    }, // computed

    methods: {
        onResetPasswordClicked() {
            if (!this.isFormValid) return;
                this.resetPasswordAsync();
        },

        async resetPasswordAsync() {
            if (!this.isFormValid) return;

            this.loading = true;

            try {
                await api.users.resetPasswordAsync(
                    this.password,
                    this.passwordConfirm,
                    this.email
                );

                toasts.success("Password restarted successfully");
                this.showDialog = true;

            } catch (error) {
                toasts.error(`Could not reset password. ${error}`);
            } finally {
                this.loading = false;
            }
        },

        sendToLogin() {
            this.$router.push({ path: "/login" });
        }
    }, // methods
};
</script>
